export default __webpack_public_path__ + "static/media/LolChampionGalleryImg_3.0dbaf712.png";